import type { SelectOption } from "@/components/ui/Select/MultiSelect";

export const ALL_OPTION_VALUE = "all";

export const withAllOption = (label: string, options: SelectOption[]): SelectOption[] => [
  { value: ALL_OPTION_VALUE, label },
  ...options,
];

export const normalizeAllSelection = (next: string[], previous: string[]): string[] => {
  if (next.length === 0) return [ALL_OPTION_VALUE];
  if (!next.includes(ALL_OPTION_VALUE)) return next;
  if (!previous.includes(ALL_OPTION_VALUE)) return [ALL_OPTION_VALUE];
  return next.filter((value) => value !== ALL_OPTION_VALUE);
};

export const stripAllSelection = (values: string[]): string[] =>
  values.filter((value) => value !== ALL_OPTION_VALUE);
